<template>
  <a-modal
    :visible.sync="visible"
    :footer="null"
    width="80%"
    :close-on-click-modal="false"
    @cancel="close"
    destroy-on-close
    centered
  >
    <template slot="title">
      <div class="search-title">
        {{ $t('message_search') }}<span>{{ finallyKeyword }}</span
        >{{ $t('message_search_tips1') }}<b>{{ totalCount }}</b
        >{{ $t('message_search_tips2') }}
      </div>
    </template>
    <div>
      <!-- 头部搜索 -->
      <div class="message-search">
        <!-- <a-range-picker v-model="searchDate" size="large" class="message-search-date" /> -->
        <a-input-search
          :placeholder="$t('com_form_keyword_input')"
          @search="handleSearch"
          enter-button
          size="large"
          v-model="keyword"
          allowClear
        />
      </div>

      <div class="message-wrapper">
        <Loading :show="true" v-if="loading" />

        <div class="message-main" v-if="searchResults && searchResults.length > 0 && !loading">
          <!-- 左侧消息分类 -->
          <div class="message-side">
            <!-- 左侧分类列表 -->
            <CategoryList
              :categoryData="searchResults"
              :currentCategory="currentCategory"
              :clickEvent="
                item => {
                  setCurrent(item);
                }
              "
              v-if="searchResults"
              :search="true"
            />
          </div>

          <!-- 右侧消息列表 -->
          <div
            v-if="currentCategory.list && currentCategory.list.length > 0"
            class="message-content-wrapper"
          >
            <div class="message-content">
              <MessageItem
                :msg="msg"
                :currentCategory="currentCategory"
                :callback="
                  () => {
                    // 重新获取列表
                    getCategoryList();
                  }
                "
                :keyword="finallyKeyword"
                v-for="msg in currentCategory.list"
                :key="msg.id"
              />
            </div>
          </div>
          <Empty v-else />
        </div>
        <div
          class="message-main"
          v-if="(!searchResults || searchResults?.length === 0) && !loading"
        >
          <Empty />
        </div>
      </div>
    </div>
  </a-modal>
</template>

<script>
import * as API from '@/api/message';
import MessageItem from './messageItem.vue';
import CategoryList from './categoryList.vue';
import momment from 'moment';
export default {
  components: {
    MessageItem,
    CategoryList,
  },
  name: 'Search',
  data() {
    return {
      searchDate: [],
      keyword: '',
      finallyKeyword: '',
      loading: false,
      visible: false,
      searchResults: null,
      currentCategory: null,
      totalCount: 0,
    };
  },
  created() {
    this.visible = this.show;

    // 默认搜索最近三个月的消息
    // this.searchDate = [
    //   momment()
    //     .subtract(3, 'months')
    //     .startOf('month')
    //     .format('YYYY-MM-DD')
    //     .valueOf(),
    //   momment()
    //     .format('YYYY-MM-DD')
    //     .valueOf(),
    // ];
  },
  methods: {
    open(keyword) {
      this.visible = true;
      this.keyword = keyword;
      if (keyword) {
        this.handleSearch();
      }
    },
    close() {
      this.visible = false;
    },
    // 搜索
    handleSearch(value) {
      this.loading = true;
      this.finallyKeyword = value || this.keyword;

      const params = {
        keyword: this.keyword,
      };

      if (this.searchDate && this.searchDate.length > 0) {
        // 时间转成时间戳
        const _date = this.searchDate.map(item => {
          return momment(item).valueOf();
        });
        params.date = _date.join('-');
      }

      this.finallyKeyword = this.keyword;

      return API.getSearch(params)
        .then(res => {
          if (res.code === 0 && res.data && res.data.items) {
            const _result = res.data?.items || null;

            // 默认选中第一个
            if (_result.length) {
              this.currentCategory = _result[0];

              // 总条数
              this.totalCount = 0;
              _result.forEach(item => {
                if (item.list) {
                  this.totalCount += item.list.length;

                  item.list.forEach(msg => {
                    // 非系统消息时，处理handle和createTime
                    if (msg.dev) {
                      msg.handle = msg.dev.handle;
                    }
                    msg.createTime = msg.createDate;
                  });
                }
              });

              console.log('_result', _result);

              this.searchResults = _result;
            } else {
              this.currentCategory = null;
            }
          } else {
            this.searchResults = null;
            this.currentCategory = null;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // 单个处理
    handleOne(msg) {
      this.$confirm({
        title: this.$t('message_confirm_notice_title'),
        content: this.$t('message_confirm_handle_one_content'),
        centered: true,
        onOk: () => {
          this.deleteLoading = true;
          this.$store.commit('setFreeze', this.$t('com_table_loading'));
          const params = {
            messageId: msg.id,
            categoryId: msg.categoryId,
            devId: msg.devId,
          };
          API.handleMtone(params)
            .then(res => {
              if (res.code === 0) {
                this.$message.success(this.$t('com_msg_success'));
                // 重新获取列表
                this.handleSearch();
              }
            })
            .finally(() => {
              this.$store.commit('setFreeze', false);
            });
        },
      });
    },
    setCurrent(item) {
      this.currentCategory = item || {};
    },
  },
};
</script>

<style lang="less" scoped>
.search-title {
  b,
  span {
    color: #1838d9;
    padding: 0 5px;
    font-weight: bold;
  }
}

.message-search {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  background: #f9f9f9;
  padding: 10px;
  border-radius: 5px;

  .message-search-date {
    width: 427px;
    margin-right: 15px;
  }
}

.message-wrapper {
  display: flex;
  min-height: 400px;
  height: 600px;

  .message-main {
    display: flex;
    width: 100%;

    // 左边
    .message-side {
      padding-right: 16px;
      height: 60vh;
      width: 350px;
    }

    // 右边
    .message-content-wrapper {
      flex: 1;
      .message-content {
        flex: 1;
        padding: 16px 0 0 12px;
        height: 60vh;
        overflow: auto;
      }
    }
  }
}
</style>
